import { ModalConfirmActionButton, ReactNodeOrString } from '@types';
import { useState } from 'react';

const useNewModal = () => {
	const [modalStatus, setModalStatus] = useState(false);
	const [modalTitle, setModalTitle] = useState<ReactNodeOrString>(null);
	const [modalContent, setModalContent] = useState<ReactNodeOrString>(null);
	const [modalButtons, setModalButtons] = useState<ModalConfirmActionButton[]>(null);

	const closeModal = () => setModalStatus(false);
	const openModal = () => setModalStatus(true);

	const updateModalContent = (title: ReactNodeOrString = null, content: ReactNodeOrString = null, button?: ModalConfirmActionButton[]): void => {
		setModalTitle(title);
		setModalContent(content);
		setModalStatus(true);
		setModalButtons(button);
	};

	return {
		modalStatus,
		modalTitle,
		modalContent,
		modalButtons,
		updateModalContent,
		closeModal,
		openModal
	};
};

export default useNewModal;
